import { sanitizeCodEnte, sanitizePipeSeparatedInput, sanitizeTextInput, sanitizeTokenInput } from './shared/utils';
import { AuthService } from './services/auth.service';

import { Injectable }  from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppInitService {

    dataProvided: boolean = false;
 
    constructor(
        private authService: AuthService
    ) { }

    Init() {
        return new Promise<void>((resolve, reject) => {
            console.log("AppInitService.init() called");
            this.clearLocalStorageData();
            this.setLocalStorageData();
            const token = sanitizeTokenInput(this.getUrlParameter('accessToken'));
            const auth_string = environment.auth_string; // this.getUrlParameter('auth_string');
            const cod_sistema = environment.cod_sistema; // this.getUrlParameter('cod_sistema');
            if (!this.dataProvided) {
                resolve();
            }
            this.authService.checkToken(token, auth_string).subscribe(
                (val) => {
                    if (val) {
                        this.authService.getToken(cod_sistema, auth_string).subscribe(
                            (newToken: string) => {
                                if (newToken) {
                                    localStorage.setItem('token', newToken);
                                    resolve();
                                } else {
                                    resolve();
                                    console.log('Token Undefined!');
                                }
                            },
                            (error) => {
                                resolve();
                            }
                        );
                    } else {
                        localStorage.removeItem('token');
                        resolve();
                    }
                },
                (error) => {
                    localStorage.removeItem('token');
                    resolve();
                }
            )
        });
    }

    private setLocalStorageData() {
        const cod_ente = sanitizeCodEnte(this.getUrlParameter('cod_ente'));
        const planimetrie = sanitizeTextInput(this.getUrlParameter('planimetrie'), 2048);
        const datiUIU = sanitizePipeSeparatedInput(this.getUrlParameter('datiUIU'), 5);
        const canmod = sanitizeTextInput(this.getUrlParameter('canmod'), 16);
        if (datiUIU.length === 5) {
            localStorage.setItem('sezione', datiUIU[0] || '');
            localStorage.setItem('foglio', datiUIU[1] || '');
            localStorage.setItem('numero', datiUIU[2] || '');
            localStorage.setItem('subalterno', datiUIU[3] || '');
            localStorage.setItem('superficieDpr', datiUIU[4] || '');
        }
        if (cod_ente) {
            localStorage.setItem('cod_ente', cod_ente);
        }
        if (planimetrie) {
            localStorage.setItem('planimetrie', planimetrie);
        }
        if (canmod && /^(0|1|true|false)$/i.test(canmod)) {
            localStorage.setItem('canmod', canmod.toLowerCase());
        }

        if (!planimetrie || !cod_ente) {
            this.dataProvided = false;
        } else {
            this.dataProvided = true;
        }
    }

    private clearLocalStorageData() {
        localStorage.removeItem('cod_ente');
        localStorage.removeItem('planimetrie');
        localStorage.removeItem('datiUIU');
        localStorage.removeItem('canmod');
    }

    private getUrlParameter(sParam: string) {
        const params = new URLSearchParams(window.location.search || '');
        const value = params.get(sParam);
        return value !== null ? value : undefined;
    }
}
